import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  IMPORT_REQUEST_STATUS,
  type EventStateImportHistoryResponse,
} from '~/app/services/knowledgeBase/eventStateImportHistory.types';
import {
  buildMockEventStateImportHistoryResponse,
  getEventStateImportHistory,
} from '~/app/services/knowledgeBase/eventStateImportHistory.service';

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;

export const useEventStateImportHistory = () => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_LIMIT);

  const query = useQuery({
    queryKey: ['event-state-import-history', page, pageSize],
    queryFn: () => getEventStateImportHistory({ page, limit: pageSize }),
    placeholderData: (previousData) =>
      previousData ??
      buildMockEventStateImportHistoryResponse({ page, limit: pageSize }),
    staleTime: 3_000,
    refetchInterval: (queryState) => {
      const data = queryState.state.data as
        | EventStateImportHistoryResponse
        | undefined;
      return data?.data.some(
        (item) => item.importStatus === IMPORT_REQUEST_STATUS.IN_PROGRESS,
      )
        ? 5_000
        : false;
    },
  });

  return {
    data: query.data?.data ?? [],
    meta: query.data?.meta,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error ? String(query.error) : null,
    refetch: query.refetch,
    page,
    pageSize,
    setPage,
    setPageSize,
  };
};
